import { SET_VIEWPORT } from '../actionTypes';

export const viewport = (state = null, action) => {
  if (action.error) return state;

  switch (action.type) {
    case SET_VIEWPORT:
      return action.payload;
    default:
      return state;
  }
};
